<template>
  <div class="tagnavigation">
    <button class="tag-arrow-left" @click="scroll(-200)">
      <i class="el-icon-arrow-left"></i>
    </button>
    <div class="tabs" ref="tabsContainer">
      <el-tag v-for="(tag, index) in tags" :key="tag.name" size="small" :closable="tag.name !== '首页'"
        :disable-transitions="false" @close="handleClose(tag, index)" @click="changeMenu(tag)"
        :effect="$route.name === tag.name ? 'dark' : 'plain'">
        {{ tag.name === "首页" ? "首页" : tag.name }}
      </el-tag>
    </div>
    <button class="tag-arrow-right" @click="scroll(200)">
      <i class="el-icon-arrow-right"></i>
    </button>
  </div>
</template>
<script>
  import {
    mapState,
    mapMutations
  } from 'vuex';
  export default {
    computed: {
      ...mapState({
        tags: state => state.tab.tabsList
      }),
      isCollapse() {
        return this.$store.state.tab.isCollapse
      }
    },
    methods: {
      handleClose(tag, index) {
        let length = this.tags.length - 1
        this.close(tag, 'tag')
        if (tag.name !== this.$route.name) {
          return
        }
        if (index === length) {
          this.$router.push({
            name: this.tags[index - 1].name
          })
          this.$store.commit('selectMenu', this.tags[index - 1])
        } else {
          this.$router.push({
            name: this.tags[index].name
          })
          this.$store.commit('selectMenu', this.tags[index])
        }
      },
      ...mapMutations({
        close: 'closeTab'
      }),
      changeMenu(item) {
        const currentPath = this.$route.path;
        const targetPath = `${item.path}`;
        if (currentPath !== targetPath) {
          this.$router.push({
            name: item.name
          })
          this.$store.commit('selectMenu', item)
        }
      },
      scroll(distance) {
        const container = this.$refs.tabsContainer;
        container.scrollLeft += distance;
      }
    }
  }
</script>
<style scoped>
  @import "../assets/css/index.less";

  ::-webkit-scrollbar {
    display: none;
  }

  .tabs {
    display: flex;
    overflow-x: auto;
    /* 启用横向滚动 */
    -webkit-overflow-scrolling: touch;
    /* 移动端平滑滚动 */
    white-space: nowrap;
    /* 防止换行 */
    padding: 10px 0;
    /* 可选：上下留点空间 */
    scroll-behavior: smooth;
    /* 平滑滚动（可选） */
  }

  .el-tag {
    flex-shrink: 0;
    /* 防止标签被压缩 */
    margin-right: 8px;
    /* 标签间距 */
  }

  .tagnavigation {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .tag-arrow-left,
  .tag-arrow-right {
    background: none;
    border: none;
    cursor: pointer;
    padding: 5px;
    color: #93a4c7;

    &:hover {
      color: #409eff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Tags.vue